import { formatFileSize, formatExpiredTime } from '@/utils/common.js';
import { emoji } from '@/utils/im/emoji.js';

var _$encode = function (_map, _content) {
  _content = '' + _content;
  if (!_map || !_content) {
    return _content || '';
  }
  return _content.replace(_map.r, function ($1) {
    var _result = _map[!_map.i ? $1.toLowerCase() : $1];
    return _result != null ? _result : $1;
  });
};

var _$escape = (function () {
  var _reg = /<br\/?>$/,
    _map = {
      r: /\<|\>|\&|\r|\n|\s|\'|\"/g,
      '<': '&lt;', '>': '&gt;', '&': '&amp;', ' ': '&nbsp;',
      '"': '&quot;', "'": '&#39;', '\n': '<br/>', '\r': ''
    };
  return function (_content) {
    _content = _$encode(_map, _content);
    return _content.replace(_reg, '<br/><br/>');
  };
})();

//通过正则替换掉文本消息中的emoji表情
function buildEmoji(text) {
  var re = /\[([^\]\[]*)\]/g;
  var matches = text.match(re) || [];
  for (var i = 0, len = matches.length; i < len; ++i) {
    let key = matches[i];
    if (emoji[key]) {
      let file = emoji[key].file;
      text = text.replace(key, `<img src="${require(`@/assets/emoji/${file}`)}" class="emoji-img" />`);
    }
  }
  return text;
}

//当前会话列表消息
export function getMessage(msg, color) {
  var str = '';
  var url = msg.file ? _$escape(msg.file.url) : '';
  var sentStr = (msg.flow === 'in') ? "收到" : "发送";
  // 1.3.3
  var { _matching } = msg || {};
  var { result, text, ext } = _matching || {};
  var qaq = result && result === "FAQ";
  var mtitle = qaq ? "匹配问答：" : "匹配词槽：";
  var gtitle = text ? mtitle + text : "未识别";
  var more = qaq && ext && ext.libraryId ? `<span onclick="handleCheck('${ext.libraryId}', '${ext.id}')" class="u-btn">查看详情</span>` : "";
  var matching = _matching ? `<div style="height: 37px;"><div class='text-content text-matching' title='${gtitle}'><span onmouseover="handleHover('${qaq}')" class="u-span ${qaq && 'u-fixw'}">${gtitle}</span>${more}</div></div>`: "";
  // console.log("matching ==>", msg._matching);
  switch (msg.type) {
    case 'text':
      var re = /(http:\/\/[\w.\/]+)(?![^<]+>)/gi; // 识别链接
      var _reg = /<[^<>]+>/g;
      if (!msg.text) {
        break;
      }
      str = _reg.test(msg.text) ? msg.text: _$escape(msg.text);
      str = str.replace(re, "<a href='$1' target='_blank'>$1</a>");
      str = buildEmoji(str);
      if (msg.flow === 'out') {
        str = `<div class='text-content' style='background: ${color}'>${str}</div>${matching}`
      } else {
        str = "<div class='text-content  sds'>" + str + "</div>";
      }

      break;
    case 'image':
      if (msg.status === -1) {
        str = '<p>[' + msg.message.message + ']</p>';
      } else {
        if (url) {
          // url = nim.viewImageSync({
          //   url: url
          // })
        }
        // msg.file.url = _$escape(msg.file.url);
        // msg.file.url = nim.viewImageSync({
        //     url: msg.file.url
        // })
        // str = '<a href="' + msg.file.url + '?imageView" target="_blank"><img onload="loadImg()" data-src="' + msg.file.url + '" src="' + msg.file.url + '?imageView&thumbnail=200x0&quality=85"/></a>';
        str = '<a class="download-image" href="' + url + '" target="_blank"><img data-src="' + url + '" src="' + url + '"/></a>';
      }
      break;
    case 'file':
      if (msg.status === -1) {
        str = '<p>[' + msg.message.message + ']</p>';
      } else {
        if (/png|jpg|bmp|jpeg|gif/i.test(msg.file.ext)) {
          // msg.file.url = _$escape(msg.file.url);
          // msg.file.url = nim.viewImageSync({
          //     url: msg.file.url
          // })
          // str = '<a class="f-maxWid" href="' + msg.file.url + '?imageView" target="_blank"><img data-src="' + msg.file.url + '" src="' + msg.file.url + '?imageView&thumbnail=200x0&quality=85"/></a>';
          if (url) {
            // url = nim.viewImageSync({
            //   url: url
            // })
          }
          str = '<a class="download-image" href="' + url + '" target="_blank"><img data-src="' + url + '" src="' + url + '"/></a>';
        } else if (!/exe|bat/i.test(msg.file.ext)) {
          if (msg.file && !msg.isLocalMsg) {
            url += msg.file.url.indexOf('?') === -1 ? '?' : '&'
            url += 'download=' + encodeURI(_$escape(msg.file.name));
          }

          //对文件名长度做处理，最多显示7个字
          const fileSuffixName = '\.' + msg.file.ext;
          const regx = new RegExp(fileSuffixName, 'g');
          let fileName = msg.file.name.replace(regx, '');
          if (fileName.length > 7) {
            fileName = fileName.substring(0, 7) + '...' + fileSuffixName;
          } else {
            fileName = fileName + fileSuffixName;
          }

          // string_my = `
          //   <div class="download-file">
          //     <i class="iconfont icon-text"></i>
          //     <div class="download-file-con">
          //       <div class="file-con-top">
          //         <span class="file-name">${fileName}</span>
          //         <span class="file-size">${formatFileSize(msg.file.size)}</span>
          //       </div>
          //       <div class="file-con-bottom">
          //         <span class="file-time">${formatExpiredTime(msg.time)}过期</span>
          //         <a class="file-status" href="${url}">下载</a>
          //       </div>
          //     </div>
          //   </div>
          // `

          const svgUrl = require('@/assets/2xicon.svg');

          const string_my = `
            <div class="download-file">
              <img src="${svgUrl}" class="icon-text"/>
              <div class="download-file-con">
                <div class="file-con-top">
                  <span class="file-name wes">${fileName}</span>
                  <span class="file-size wes">${formatFileSize(msg.file.size)}</span>
                </div>
                <div class="file-con-bottom">
                  <span class="file-time">${formatExpiredTime(msg.time)}过期</span>
                  <a class="file-status" href="${url}">下载</a>
                </div>
              </div>
            </div>
          `
          if (msg.file.md5) {
            str = {
              url,
              fileName,
              size: formatFileSize(msg.file.size),
              time: formatExpiredTime(msg.time)
            }
          } else {
            str = string_my
          }
          // str = '<a href="' + url + '" target="_blank" class="download-file f-maxWid"><i class="iconfont icon-text"></i><div class="download-file"><p>' + _$escape(msg.file.name) + '<p><div></a>';
        } else {
          str = '<p>[非法文件，已被本站拦截]</p>';
        }
      }
      break;
    case 'tip':
      str = msg.tip;
      break;
    case 'video':
      if (msg.file && !msg.isLocalMsg) {
        url += msg.file.url.indexOf('?') === -1 ? '?' : '&'
        url += 'download=' + encodeURI(_$escape(msg.file.name));
      }
      // str = '<a href="' + url + '" target="_blank" class="download-file"><span class="icon icon-file2"></span>[你收到了一条视频消息]</a>';
      str = '<video x5-video-player-type="h5-page" src= "' + url + '" controls>您的浏览器不支持 video 标签。</video>';
      break;
    case 'audio':
      // if (!!window.Audio) {
      //   var audioDur = Math.round((msg.file.dur) / 1000)
      //   var unread = !msg.localCustom
      //   if (msg.from === userUID && msg.from !== msg.to) {
      //     str = '<div class="u-audio j-mbox right" style="width:' + (100 + audioDur) + 'px"> <a href="javascript:;" class="j-play playAudio" data-ext="' + msg.file.ext + '" data-dur="' + msg.file.dur + '"  data-src="' + url + '">点击播放</a><b class="j-duration">' + audioDur + '"</b><span class="u-icn u-icn-play" title="播放音频"></span></div>'
      //   } else {
      //     str = '<div class="u-audio j-mbox left ' + (unread ? 'unreadAudio' : '') + '" style="width:' + (100 + audioDur) + 'px"> <a href="javascript:;" class="j-play playAudio" data-ext="' + msg.file.ext + '" data-dur="' + msg.file.dur + '" data-id="' + msg.idClient + '" data-src="' + url + '">点击播放</a><b class="j-duration">' + audioDur + '"</b><span class="u-icn u-icn-play" title="播放音频"></span></div>'
      //   }
      // } else {
      //   str = '<a href="' + url + '" target="_blank" class="download-file"><span class="icon icon-file2"></span>[' + sentStr + '一条语音消息]</a>';
      // }
      if (msg.file && !msg.isLocalMsg) {
        url += msg.file.url.indexOf('?') === -1 ? '?' : '&'
        url += 'download=' + encodeURI(_$escape(msg.file.name));
      }
      str = '<audio src= "' + url + '" controls>您的浏览器不支持 audio 标签。</audio>';
      break;
    // case 'geo':
    //   str = sentStr + '一条[地理位置]消息';
    //   break;
    // case 'custom':
    //   var content = JSON.parse(msg.content);
    //   if (content.type === 1) {
    //     str = sentStr + '一条[猜拳]消息,请到手机或电脑客户端查看';
    //   } else if (content.type === 2) {
    //     str = sentStr + '一条[阅后即焚]消息,请到手机或电脑客户端查看';
    //   } else if (content.type === 3) {
    //     var catalog = _$escape(content.data.catalog),
    //       chartvar = _$escape(content.data.chartlet);
    //     str = '<img class="chartlet" onload="loadImg()" src="./images/' + catalog + '/' + chartvar + '.png">';
    //   } else if (content.type == 4) {
    //     str = msg.fromNick + '发起了[白板互动]';
    //   } else {
    //     str = sentStr + '一条[自定义]消息，请到手机或电脑客户端查看';
    //   }
    //   break;
    case 'robot':
      str = sentStr + '一条[机器人]消息,请到手机或电脑客户端查看';
      break
    default:
      if (msg && msg.attach && msg.attach.netcallType !== undefined) {
        // var netcallType = msg.attach.netcallType;
        // var netcallTypeText = netcallType === Netcall.NETCALL_TYPE_VIDEO ? '视频' : '音频';
        // if (msg.attach && msg.attach.type === "netcallBill") {
        //   str = '通话' + (msg.flow === "in" ? "接听" : "拨打") + "时长 " + getNetcallDurationText(msg.attach.duration);
        // } else if (msg.attach && msg.attach.type === "netcallMiss") {
        //   str = "未接听";
        // }
      } else {
        str = sentStr + '一条[未知消息类型]消息';
      }
      break;
  }
  return str;
}

//获取消息的类名
export function getMessageClass(msg) {
  let msgClassName = '';
  switch (msg.type) {
    case 'text':
      msgClassName = 'text';
      break;
    case 'image':
      msgClassName = 'image';
      break;
    case 'file':
      msgClassName = 'file';
      break;
    default:
      msgClassName = '';
      break;
  }
  return msgClassName;
}

//获取最后一组会话信息
export function getLastGroupMsgs(msgs) {
  let lastGroupMsgs = [];
  for (let i = 0; i < msgs.length; i++) {
    let msg = msgs[i];
    if (msg.type === 'custom') {
      let custom = msg.custom && JSON.parse(msg.custom);
      if (custom.type != 0) {
        lastGroupMsgs.push(msg);
      } else {
        break;
      }
    } else {
      lastGroupMsgs.push(msg);
    }
  }
  return lastGroupMsgs;
}

//获取当前会话的对话id
export function getConversationId(msgs) {
  let conversationId = '';
  let lastGroupMsgs = getLastGroupMsgs(msgs);
  // 如果最后一组对话已经结束，则没有conversationId
  let conversationFinished = lastGroupMsgs.some((item) => {
    return item.type === 'custom' && item.custom && JSON.parse(item.custom).type == 3;
  });
  console.log('lastGroupMsgs', lastGroupMsgs);
  console.log('conversationFinished', conversationFinished);
  if (!conversationFinished) {
    let startMsg = lastGroupMsgs.find((item) => {
      return item.type == 'custom' && item.custom && JSON.parse(item.custom).type == 1;
    });
    console.log('找到建立会话的消息，里边有对应的conversationId字段---startMsg', startMsg);
    if (startMsg && startMsg.content) {
      let msgContent = JSON.parse(startMsg.content);
      let msgData = msgContent.msg;
      console.log('msgContent', msgContent);
      if (typeof msgData == 'string' && msgData.indexOf('conversationId') > -1) {
        msgData = JSON.parse(msgData);
      }
      conversationId = msgData.conversationId;

    } else {
      // 如果对话消息太多，第一次请求出来的里边没有建立会话的那条消息，则在普通的文本消息里找conversationId
      let startMsgs = lastGroupMsgs.filter((item) => {
        return item.type == 'text' && item.custom;
      });
      if (startMsgs && startMsgs.length) {
        startMsg = startMsgs[0];
        conversationId = startMsg.custom && JSON.parse(startMsg.custom).conversationId;
      }
    }
    return conversationId;
  }
}

// 处理词槽数据
export function setCatchingCurrSessionMsgs(msgsList, msgs) {
  // console.log("setCatchingCurrSessionMsgs ==>", msgsList, msgs);
  if(!msgsList || !msgs) return [];
  let msgItem = Object.assign({}, msgs);
  let custom = msgItem.custom && JSON.parse(msgItem.custom);
  if(msgItem.type !== "custom" || custom.type !== 13) return msgsList;

  let content = msgItem.content && JSON.parse(msgItem.content);
  let msgId = content.msg && content.msg.msgId;
  // let tempMsgsList = JSON.parse(JSON.stringify(msgsList));
  let tempMsgsList = msgsList;
  tempMsgsList.forEach((item, index) => {
    if(item.idClient === msgId) {
      item._matching = content.msg;
      item.idClient = item.idClient + '--' + parseInt(Math.random()*1000000000);
    }
  });
  return tempMsgsList;
};

// sub iframe send message
export function iframeMessageSend({ type = "", payload = {} } = {}) {
  if(!type) return Error("iframeMessageSend 缺少type参数");
  try {
    window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
      type,
      payload
    }), '*');
  } catch (error) {
    console.error("iframeMessageSend ==> error");
  }
};



// WEBPACK FOOTER //
// ./src/utils/im/validate.js